import React from "react";
import { BiSolidInfoCircle } from "react-icons/bi";
import { GoAlertFill } from "react-icons/go";

const variants = {
  error: {
    className: "bg-[var(--inyc-notice-bg-color)] text-[var(--inyc-primary-text-color)] border-[var(--inyc-input-border-color)]",
    Icon: <GoAlertFill size={20} className="min-w-[20px] min-h-[20px]" />,
  },
  default: {
    className: "bg-[var(--inyc-primary)] text-[var(--inyc-primary-text-color)] border-divider",
    Icon: <BiSolidInfoCircle size={20} 
    color="var(--inyc-primary-text-color)"
    className="min-w-[20px] min-h-[20px]" />,
  },
};

const Notice = (props) => {
  const { children, className, variant, noicon, textClassName } = props;

  const { className: variantClassName, Icon } = variants[variant] || variants.default;
  return (
    <div
      className={`${variantClassName} w-fit rounded-kit-sm border-[1px] text-kit-sm
      gap-kit-10
      flex-row 
      text-start 
      p-kit-16 
      flex
      items-center 
      ${className}`}
    >
      {!noicon && Icon}
      <div className={`font-['Primary-Regular'] ${textClassName || "text-[var(--inyc-primary-text-color)]"}`}>
        {children}
      </div>
    </div>
  );
};

export default Notice;
